import { Controller } from 'stimulus';
import { copyText } from 'utils/clipboard';

/**
 * Copies the field's value when its Copy button is clicked. The button flips to "Copied!" for 3s,
 * then reverts to "Copy". With data-copy-to-clipboard-auto-value="true" it also copies on connect;
 * if that succeeds, or when the Copy button is clicked after a blocked auto-copy, the button does the
 * same flip and the status target (confirmation text) is revealed and stays visible. If the browser
 * blocks the copy (no user gesture), nothing claims success.
 */
export default class CopyToClipboard extends Controller {
  static targets = ['status', 'button'];
  static values = { auto: Boolean };

  async connect() {
    if (!this.autoValue) return;

    const input = this.element.querySelector('.clipboard-data');
    if (!input || !(await copyText(input.value))) return;

    this.confirm();
  }

  async click(e) {
    const button = e.currentTarget;
    const input = this.element.querySelector('.clipboard-data');
    if (!(await copyText(input.value))) return;

    this.confirm(button);
  }

  // Reveals the confirmation text and flips the Copy button(s). Without an explicit button, flips them all,
  // since the field's own button and the hide_field one share the target and only one is visible.
  confirm(button) {
    if (this.hasStatusTarget) this.statusTarget.classList.remove('hidden');
    (button ? [button] : this.buttonTargets).forEach(btn => this.updateButtonText(btn, 'Copy'));
  }

  updateButtonText(btn, btnText) {
    btn.textContent = 'Copied!';
    setTimeout(() => (btn.textContent = btnText), 3000);
  }
}
